import React from 'react';
import AddBlog from './add-blog';

// This component reuses the AddBlog component in edit mode
const EditBlogAdminPage = () => {
  return <AddBlog />;
};

export default EditBlogAdminPage;
